module.exports = __webpack_public_path__ + "static/media/  (49).340bcc39.jpg";